export const NEWS_ARTICLES_OVERVIEW_LIMIT = 9;
